import SetNoThankYouPendingActionReport from 'vRoot/rfp-hotel/bid-manager/actions/action-report/SetNoThankYouPendingActionReport.vue';
import noop from 'lodash/noop';
import {mainAPI, notificationUtils} from 'root/angular-injector-provider';
import {
  RESPONDED,
  NEGOTIATION_FINALIZED,
  FINAL_AGREEMENT_PENDING,
  statusMatches,
  NO_LONGER_INTERESTED
} from 'rfp/bid-manager/main/core/actions/action/status';

export default function setNoThankYouPending(actionResultHandler){
  return function (selectedBidsReport) {
    return {
      label: 'Set "No Thank You" Pending',
      icon: 'thumb_down',
      isAvailable: () => {
        return statusMatches(selectedBidsReport.statuses, [RESPONDED, NEGOTIATION_FINALIZED, FINAL_AGREEMENT_PENDING, NO_LONGER_INTERESTED])
      },
      action: () => {
        notificationUtils().onSave(() => mainAPI().setNoThankYouPending(selectedBidsReport.bidsIds))
          .then(actionReport => actionResultHandler(actionReport, selectedBidsReport.bids, SetNoThankYouPendingActionReport))
          .catch(noop);
      }
    }
  };
}
